import { render, staticRenderFns } from "./SharesLabel.vue?vue&type=template&id=33a1b3cd&scoped=true"
import script from "./SharesLabel.vue?vue&type=script&lang=js"
export * from "./SharesLabel.vue?vue&type=script&lang=js"
import style0 from "./SharesLabel.vue?vue&type=style&index=0&id=33a1b3cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1b3cd",
  null
  
)

export default component.exports